import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Imgix from '../../imgix'
import { IMGIX_CROP_OPTIONS } from '../../../constants'
import BrandLogo from '../brand-logo'

import styles from './hero-image.css'

function HeroImage({
  className,
  image,
  title,
  aspectRatio,
  brandLogo,
  showSquareHeroImage
}) {
  const crop = showSquareHeroImage ? IMGIX_CROP_OPTIONS.HOTSPOT : IMGIX_CROP_OPTIONS.KEY_ART
  const ar = showSquareHeroImage ? '1:1' : aspectRatio

  return (
    <div className={classnames(className, styles.wrapper)}>
      <div className={classnames(className, styles.heroImageWrapper)}>
        <Imgix
          className={className}
          src={image}
          alt={title}
          imgixParams={{ fit: 'crop', crop, ar }}
          sizes="100vw"
        />
        <div className={styles.gradientBottom} />

        <div className={styles.gradientLeft} />

        {/* Brand logo on tablet and web view */}
        <div className={styles.brandLogoContainer}>
          <BrandLogo logo={brandLogo} />
        </div>
      </div>
    </div>
  )
}

HeroImage.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  aspectRatio: PropTypes.string,
  brandLogo: PropTypes.string,
  showSquareHeroImage: PropTypes.bool
}

HeroImage.defaultProps = {
  title: '',
  className: '',
  aspectRatio: '16:9',
  brandLogo: '',
  showSquareHeroImage: false
}

export default HeroImage
